import { TokenType as tt } from 'sucrase/dist/parser/tokenizer/types';

export const leftHandSideExpressionTokens = [
  tt.num,
  tt.bigint,
  tt.decimal,
  tt.regexp,
  tt.string,
  tt.name,
  tt.dot,
  tt.questionDot,
  tt.template,
  tt.plus,
  tt.minus,
  tt.star,
  tt._this,
  tt._yield,
  tt._null,
  tt._true,
  tt._false,
  tt._function,
  tt._class,
  tt._extends,
  tt._async,
  tt._super,
  tt._new,
  tt._import,
];

export const assignmentExpressionTokens = [
  ...leftHandSideExpressionTokens,
  tt._delete,
  tt._void,
  tt._typeof,
  tt.plus,
  tt.minus,
  tt.tilde,
  tt.bang,
  tt.preIncDec,
  tt.postIncDec,
  tt.exponent,
  tt.star,
  tt.slash,
  tt.modulo,
  tt.bitShift,
  tt.lessThan,
  tt.greaterThan,
  tt.relationalOrEqual,
  tt._instanceof,
  tt._in,
  tt.equality,
  tt.bitwiseAND,
  tt.bitwiseXOR,
  tt.bitwiseOR,
  tt.logicalAND,
  tt.logicalOR,
  tt.nullishCoalescing,
  tt.question,
  tt.colon,
  tt.arrow,
  tt.eq,
  tt.assign,
];
